import React from 'react';
import {BreakpointProvider} from '../context/BreakpointContext';
import {Fonts, defaultTheme, Reset} from '../utils/styling';
import NavBar from '../components/Navigation/NavBar';
import Footer from '../components/Footer';
import {MainWithBanner} from '../components/MainWithBanner';
import PageTransition from '../utils/PageTransition';
import {ThemeProvider} from 'styled-components';
import {GlobalContextProvider} from '../context/GlobalContext';

const PrimaryLayout = ({children, location, pageContext}) => {
  if (pageContext.layout === 'empty') {
    return (
        <>
          {children}
        </>
    );
  } else {
    return (
        <ThemeProvider theme={defaultTheme}>
          <GlobalContextProvider>
            <BreakpointProvider>
              <Reset/>
              <Fonts/>
              <MainWithBanner>
                <NavBar location={location}/>
                <PageTransition location={location}>
                  {children}
                </PageTransition>
                <Footer location={location}/>
              </MainWithBanner>
            </BreakpointProvider>
          </GlobalContextProvider>
        </ThemeProvider>
    );
  }
};

export default PrimaryLayout;
